import { BadgeCheck, Hammer, MapPin, Lightbulb, Ruler, FileText, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "@/lib/Reveal";
import { BENEFITS, scrollToId } from "@/lib/site";

const ICONS = { BadgeCheck, Hammer, MapPin, Lightbulb, Ruler, FileText };

export default function WhyChooseUs() {
    return (
        <section id="why-us" data-testid="why-choose-us-section" className="py-20 lg:py-28 bg-[#141414] noise-overlay relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="max-w-2xl mb-14">
                    <Reveal>
                        <Overline light>Why Choose Appex Smart Solution</Overline>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mt-4 leading-[1.05]">
                            Built on trust,
                            <br />
                            finished with care
                        </h2>
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {BENEFITS.map((b, i) => {
                        const Icon = ICONS[b.icon];
                        return (
                            <Reveal key={b.title} delay={(i % 3) * 0.08} className="h-full">
                                <div
                                    data-testid={`benefit-card-${i + 1}`}
                                    className="group h-full rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-7 sm:p-8 transition-[background-color,border-color,transform] duration-300 hover:bg-white/[0.08] hover:border-[#E85A1D]/50 hover:-translate-y-1"
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="w-12 h-12 rounded-xl bg-[#E85A1D]/15 flex items-center justify-center">
                                            <Icon className="w-6 h-6 text-[#E85A1D]" strokeWidth={2} />
                                        </div>
                                        <span className="font-mono-brand text-xs text-white/30 font-semibold">
                                            0{i + 1}
                                        </span>
                                    </div>
                                    <h3 className="font-display text-xl font-bold tracking-tight text-white mt-6">
                                        {b.title}
                                    </h3>
                                    <p className="mt-3 text-sm text-white/60 leading-relaxed">{b.desc}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>

                <Reveal delay={0.15}>
                    <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 rounded-2xl bg-[#E85A1D] px-8 py-8 sm:px-10">
                        <div>
                            <h3 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-white">
                                Ready to talk about your project?
                            </h3>
                            <p className="text-white/80 text-sm sm:text-base mt-2">
                                Free, no-obligation quotes across Luton and surrounding areas.
                            </p>
                        </div>
                        <button
                            onClick={() => scrollToId("contact")}
                            className="group shrink-0 flex items-center gap-2 bg-[#141414] text-white font-bold px-8 py-4 rounded-full text-sm hover:bg-neutral-900 transition-colors duration-200"
                        >
                            Request a Free Quote
                            <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
                        </button>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
